module.exports = __webpack_public_path__ + "img/login-pic.1aa47548.png";